import { render } from "./StatementsView.vue?vue&type=template&id=184f1faf&scoped=true"
import script from "./StatementsView.vue?vue&type=script&lang=js"
export * from "./StatementsView.vue?vue&type=script&lang=js"

import "./StatementsView.vue?vue&type=style&index=0&id=184f1faf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184f1faf"]])

export default __exports__